import { Component, Input } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';

@Component({
    selector: 'partner-appconfig-recommended-products',
    templateUrl: './partner-appconfig-recommended-products.component.html',
    styleUrls: ['./partner-appconfig-recommended-products.component.scss']
})
export class PartnerAppConfigRecommendedProductsComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private appData: AppDataService, public configService: ConfigService) { }

}
